import "babel-polyfill";
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import OneSignalVue from 'onesignal-vue'
import axios from 'axios'
import Router from 'vue-router'
import routes from './routes'
import BootstrapVue from 'bootstrap-vue'
import store from "./store";
import mixin from "./mixin";
import App from './App'
import HttpInterceptor from "./helpers/http-interceptor";
import PrimeVue from 'primevue/config';

import '@/assets/temp.scss'
import '@/assets/overrules.scss'
import '@/assets/themes.scss'

import 'primevue/resources/themes/bootstrap4-light-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueSmoothScroll from 'vue2-smooth-scroll'

import 'vue-search-select/dist/VueSearchSelect.css';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import icons from "./fontawesome-icons"
import menuStructure from "./config/menu-structure";

library.add(icons)

/** * * * * * * * * * * *
 * OmniStock components *
 * * * * * * * * * * * **/

import OmniAlertInline      from "@/components/OmniStock/OmniAlertInline.vue";
import OmniButton           from "@/components/OmniStock/OmniButton.vue";
import OmniButtonCollection from "@/components/OmniStock/OmniButtonCollection.vue";
import OmniCard             from "@/components/OmniStock/OmniCard.vue";
import OmniCardTitle        from "@/components/OmniStock/OmniCardTitle.vue";
import OmniCheckboxes       from "@/components/OmniStock/Forms/OmniCheckboxes";
import OmniDraggableList    from "@/components/OmniStock/Forms/OmniDraggableList";
import OmniDropdownCard     from "@/components/OmniStock/OmniDropdownCard";
import OmniDropdownIcon     from "@/components/OmniStock/OmniDropdownIcon";
import OmniPageTitle        from "@/components/OmniStock/OmniPageTitle.vue";
import OmniSidebar          from "@/components/OmniStock/OmniSidebar";
import OmniTableSmall       from "@/components/OmniStock/OmniTable/OmniTableSmall";
import ThemePicker          from "@/components/OmniStock/ThemePicker/ThemePicker.vue";

Vue.component('OmniAlertInline', OmniAlertInline);
Vue.component('OmniButton', OmniButton);
Vue.component('OmniButtonCollection', OmniButtonCollection);
Vue.component('OmniCard', OmniCard);
Vue.component('OmniCardTitle', OmniCardTitle);
Vue.component('OmniCheckboxes', OmniCheckboxes);
Vue.component('OmniDraggableList', OmniDraggableList);
Vue.component('OmniDropdownCard', OmniDropdownCard);
Vue.component('OmniDropdownIcon', OmniDropdownIcon);
Vue.component('OmniPageTitle', OmniPageTitle);
Vue.component('OmniSidebar', OmniSidebar);
Vue.component('OmniTableSmall', OmniTableSmall);
Vue.component('ThemePicker', ThemePicker);


// Configure http interceptor
let http = new HttpInterceptor
axios.interceptors.response.use(
    response => response,
    (response) => http.responseErrorHandler(response),
)

window.AppVars = {}
Vue.prototype.$appVars = window.AppVars
Vue.prototype.$http = axios
Vue.config.productionTip = false

// Global alerts: You can call this.$alert() to show any kind of message
Vue.prototype.$_alerts = []
Vue.prototype.$alert = function(message, type = 'success', autoClose = true) {
    this.$_alerts.push({
        type: type,
        message: message,
        autoClose: autoClose
    })
}

Vue.use(BootstrapVue)
Vue.use(VueSmoothScroll)
Vue.use(Router)
Vue.use(VueI18n)
Vue.use(OneSignalVue)
Vue.use(PrimeVue)
Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('FontAwesomeLayers', FontAwesomeLayers)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.mixin(mixin)

const router = new Router({
    routes,
    base: '',
    mode: 'history'
})

/**
 * Initializes internationalization (i18n) for a Vue application.
 * Tries to fetch translations from an API and falls back to localStorage if the API is unavailable.
 * Updates the localStorage with new translations if the API call is successful.
 */

/**
 * Load translations from localStorage or set to an empty object if none exist.
 * @type {Object.<string, string>}
 */
const translations = JSON.parse(localStorage.getItem('translationCache')) || {};

/**
 * Fetch translations from the API.
 * On success, replace the cached translations by the new ones and update localStorage.
 * On failure, log the error and continue with cached translations.
 */
axios.get('/api/frontend/translations')
    .then(response => {
        /** @type {{ [key: string]: string }} */
        const responseData = response.data;

        // Merge API translations with existing ones
        Object.assign(translations, responseData);

        // Update localStorage with the latest translations
        localStorage.setItem('translationCache', JSON.stringify(translations));
    }).catch(error => {
    console.error('Error while fetching translations', error);
});

/**
 * Our VueI18n instance with the translations.
 * @type {VueI18n}
 */
export const i18n = new VueI18n({
    locale: 'nl-NL',
    messages: translations,
    silentTranslationWarn: true,
    // ...
});

window.onload = () => {
    new Vue({
        i18n,
        router,
        store,
        data: {
            forceReloadRouterView: 0,
            isSavingConfig: false,
            hasUnsavedChanges: false, // usage: this.$root.hasUnsavedChanges = true;
        },
        computed: {
            routerKey() {
                if (!this.$route || !this.$route.matched.length) return null

                let relevantParams = this.$route.matched[0].path.match(/\/:[a-z0-9]+[^\/]/ig)
                if (!relevantParams) {
                    relevantParams = []
                }

                let relevantValues = []
                for (let i = 0; i < relevantParams.length; i++) {
                    relevantValues.push(this.$route.params[relevantParams[i].substring(2)])
                }

                return `${this.$route.matched[0].path}_${this.forceReloadRouterView}_${relevantValues.join('+')}`
            },

            /**
             * Combines all front-end parameters from config into one object,
             * ordered by group, in order to make it more easily accessible.
             * @returns {Object} frontendParameters
             */
            frontendParameters() {
                const data = this.$store.state?.config?.settings;

                // Check if data exists
                if (!data) {
                    return {};
                }

                // Get the keys from the data that start with 'frontend-parameters'
                const frontendParameterKeys = Object.keys(data).filter(key => key.startsWith('frontend-parameters'));

                // Process and put into a single object, extracting the corresponding values from the data
                const frontendParameters = frontendParameterKeys.reduce(
                    (acc, key) =>
                    {
                        const groupName = key.split('.')[1]; // Extract the group name, e.g., 'group-one' from 'frontend-parameters.group-one'

                        // Add the group to the accumulator, e.g. { "group-one": {...}, "group-two": {...} }
                        acc[groupName] = data[key];
                        return acc;
                    },
                    {}
                );

                return frontendParameters;
            },

            activeTheme() {
                try {
                    return this.$store.getters.getFrontendParameterValue('general', 'theme')
                } catch {
                    return 'default';
                }
            },

            activeLanguage() {
                try {
                    return this.$store.getters.getFrontendParameterValue('general', 'language')
                } catch {
                    return 'nl-NL';
                }
            }
        },
        render: h => h(App),
        errorCaptured: (e) => {
            Vue.prototype.$alert(`Er is iets misgegaan bij het laden van de pagina. Neem contact op met OmniStock.`, 'danger', false)
        },
        methods: {
            /**
             * Set a specific frontend parameter value by group, then update the backend and local state.
             * @param {String} group - The group name of the frontend parameters.
             * @param {*} values - The new values to set.
             * @param showSuccessAlert
             */
            async setFrontendParameterValues(group, values, showSuccessAlert = true) {
                // Prepare the data for the PATCH request
                const patchRequestPayload = Object.keys(values).map(k => ({
                    group,
                    key: k,
                    value: values[k]
                }));

                // Patch request
                this.isSavingConfig = true;
                return this.$http.patch(`/api/frontend/parameters`, patchRequestPayload)
                    .then(() => {
                        // Zorg dat de opgeslagen values ook goed in het geheugen staan
                        patchRequestPayload.forEach((payload) => {
                            this.$store.getters.frontendParameters[group][payload.key] = payload.value;
                        })

                        if (showSuccessAlert) {
                            this.$alert('De voorkeuren zijn opgeslagen.', 'success');
                        }
                    }).catch((error) => {
                        this.$alert('Er is een fout opgetreden bij het opslaan van de voorkeuren.', 'danger');
                        console.error('Error while saving frontend parameters', error);
                        throw error
                    }).finally(() => {
                        this.isSavingConfig = false;
                    });
            },

            /**
             * Set a specific frontend parameter value by group and key, then update the backend and local state.
             * @param {String} group - The group name of the frontend parameters.
             * @param {String} key - The key of the specific frontend parameter.
             * @param {*} value - The new value to set.
             */
            setFrontendParameterValue(group, key, value) {
                // Retrieve the current parameters for the group
                const groupValues = this.$store.getters.getFrontendParameterValues(group);

                // Update the specific key with the new value
                const updatedGroupValues = { ...groupValues, [key]: value };

                this.setFrontendParameterValues(group, updatedGroupValues);
            },
        },
        mounted() {
            document.body.dataset.theme = this.activeTheme;
        },
        watch: {
            $route: {
                immediate: true,
                handler(to, from) {
                    let pageTitle = '';

                    menuStructure.forEach(item => {
                        if (typeof item.to === 'undefined') {
                            return;
                        }

                        to.matched.forEach(match => {
                            const isRouteNameMatched = item.matchRouteNames && item.matchRouteNames.includes(match.name);
                            const isToNameMatched = item.to.name && item.to.name === match.name;

                            if (!isRouteNameMatched && !isToNameMatched) {
                                return;  // Continue to the next match if no name match is found.
                            }

                            const translatedTitle = this.$t(item.title);
                            if (translatedTitle === item.title) {
                                return;  // Skip setting page title if no internationalization string is found.
                            }

                            pageTitle = `${translatedTitle} | `;
                        });

                        document.title = `${pageTitle}OmniStock OMS`;
                    });
                }
            },
            activeTheme() {
                document.body.dataset.theme = this.activeTheme;
            },
            activeLanguage() {
                // What to do in case of a language change:
                this.$i18n.locale = this.activeLanguage;
            }
        }
    }).$mount('#app')
}
